import React, { useRef, useState, useEffect } from "react"
import { z } from "zod"
import axios from "axios"
import Form from "./elements/Form"
import Recaptcha from "./elements/Recaptcha"
import TermsConditions from "./elements/TermsConditions"
import TextAreaInput from "./elements/TextAreaInput"
import TextInput from "./elements/TextInput"
import { SCHEMA } from "./schemas"
import {
  SUCCESS_MSG,
  formTracking,
  isCaptchaMode,
  postFormData,
  sendMail,
} from "./utils"

const FORM_SCHEMA = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  message: SCHEMA.message,
  propertyId: SCHEMA.propertyAddress,
  propertyURL: SCHEMA.propertyAddress,
  propertyAddress: SCHEMA.propertyAddress,
})

const ContactTeamForm = ({ team, propertyDetails, officeDetails }) => {
  const recaptchaRef = useRef()

  // Get CSRF Token
  const [csrfToken, setCsrfToken] = useState("")
  useEffect(() => {
    // Fetch CSRF token from server
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get("/api/csrf-token")

        // console.log("csrfToken ==> response", response)

        setCsrfToken(response.data.csrfToken)
      } catch (error) {
        console.error("Error fetching CSRF token:", error)
      }
    }

    fetchCsrfToken()
  }, [])
  // Get CSRF Token

  if (!team) return null

  // console.log("propertyDetails ==>", propertyDetails, officeDetails)

  let person_name = team?.name
  let user_subject = `Contact Team - ${team?.name}`

  if (propertyDetails?.searchType === "lettings") {
    person_name = "A member of the lettings team"
    user_subject = "A member of our team"
  }
  if (propertyDetails?.searchType === "sales") {
    person_name = "A member of the sales team"
    user_subject = "A member of our team"
  }

  let toEmailCC =
    propertyDetails?.propertyId && officeDetails?.email
      ? officeDetails?.email
      : ""

  // let officeEmail = propertyDetails?.propertyURL && team?.office ?
  if (
    propertyDetails?.searchType === "lettings" &&
    propertyDetails?.propertyId &&
    officeDetails?.email_lettings
  ) {
    toEmailCC = officeDetails?.email_lettings
  }

  // console.log("toEmailCC ==>", toEmailCC, person_name)

  const FORM_CONFIG = {
    form_name: `Contact Team - ${team?.name}`,
    eventTracking: "craete-team",
    admin: {
      toEmail: `${team?.email},${toEmailCC}`,
      subject: user_subject,
      heading: `Contact Team - ${team?.name}`,
      description:
        "The following person has sent an enquiry through the website:",
    },
    user: {
      subject: user_subject,
      description: `Thank you for contacting Webbers. ${person_name} will be in touch shortly to help with your query. If you query is urgent, our Customer Care Team are available between 8am - 8pm Monday to Friday on 01271 347851.`,
    },
    labelMap: {},
  }

  const onSubmit = async (data) => {
    const token = isCaptchaMode
      ? await recaptchaRef.current?.executeAsync()
      : true

    if (token) {
      const postData = {
        first_name: data.name?.split(" ")[0],
        ...data,
        _csrf: csrfToken,
        "g-recaptcha-response": token,
        ...FORM_CONFIG,
        extra: { formConfig: FORM_CONFIG, _csrf: csrfToken, data },
      }

      const formData = new FormData()

      formData.append("data", JSON.stringify(postData))

      postFormData(formData).then(async () => {
        await sendMail(postData)
      })

      recaptchaRef.current.reset()
      formTracking({
        eventTracking: FORM_CONFIG.eventTracking,
        formName: FORM_CONFIG.form_name,
      })
    }
  }

  return (
    <div className="contact-team-form-section popup-form-section custom-form-wrap">
      <Form
        className="contact-team-form popup-form"
        validationSchema={FORM_SCHEMA}
        onSubmit={onSubmit}
        successMsg={SUCCESS_MSG}
      >
        <TextInput
          type="hidden"
          name="propertyId"
          placeholder="Property ID"
          value={`${
            propertyDetails?.propertyId ? propertyDetails?.propertyId : ""
          }`}
        />

        <TextInput
          type="hidden"
          name="propertyAddress"
          placeholder="Property Address"
          value={`${
            propertyDetails?.propertyAddress
              ? propertyDetails?.propertyAddress
              : ""
          }`}
        />

        <TextInput
          type="hidden"
          name="propertyURL"
          placeholder="Property URL"
          value={
            propertyDetails?.propertyUrl ? propertyDetails?.propertyUrl : ""
          }
        />

        <TextInput name="name" placeholder="Name" label="Name" />
        <TextInput
          name="email"
          placeholder="Email"
          type="email"
          label="Email Address"
        />
        <TextInput
          name="telephone"
          placeholder="Phone Number"
          type="tel"
          label="Phone"
        />
        <TextAreaInput name="message" placeholder="Message" label="Message" />
        <button className="button button-primary" type="submit">
          <span>Contact</span>
        </button>
        <Recaptcha recaptchaRef={recaptchaRef} />
      </Form>
      <TermsConditions />
    </div>
  )
}

export default ContactTeamForm
